import React from 'react';
import ContentLoader from 'react-content-loader';
import * as StyledSettings from '../../myPost/settings/settings.styles';

const MyShipmentsTileLoader = () => (
	<StyledSettings.Card>
		<ContentLoader
			height={95}
			width={829}
			speed={2}
			backgroundColor="#f3f3f3"
			style={{ border: '0px' }}
			foregroundColor="#ecebeb">
			<circle cx="800" cy="24" r="10" />
			<rect x="0" y="45" rx="0" ry="0" width="829" height="1" />
			<rect x="20" y="12" rx="0" ry="0" width="150" height="23" />
			<rect x="20" y="56" rx="0" ry="0" width="120" height="14" />
			<rect x="20" y="72" rx="0" ry="0" width="220" height="14" />
		</ContentLoader>
	</StyledSettings.Card>
);

export default MyShipmentsTileLoader;
